import React, { useEffect, useState } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { PersonaVerification } from 'components/persona';
import { ROUTES, pathnames } from 'lib/routes';
import CountryForm from './country';
import NonResidentForm from './non-resident';
import application from 'lib/application';

const BeneficialOwner = () => {
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  const location = useLocation();
  const history = useHistory();
  const individual = values.individual;
  const country = values.individual.address.country;
  const [personaPayload, setPersonaPayload] = useState(null);

  useEffect(() => {
    if (individual.persona_inquiry_status === 'completed') {
      history.replace(ROUTES[pathnames.beneficial_owner_verification].next);
    }
  }, [individual.persona_inquiry_status, history]);

  useEffect(() => {
    const getInquiryDetails = async () => {
      const result = await application.retrievePersonaInquiry();

      if (!result || result.error) {
        // no inquiry found: start new inquiry with basic embedded flow
        const residentTemplate = 'tmpl_3siTuM7hdEZdpJpodqNzUsyB';
        const nonResidentTemplate = 'tmpl_C9DWoVq8GeF64SuMNhZUrmin';
        setPersonaPayload({
          personaAccountId: individual.persona_account_id,
          personaTemplate:
            country === 'US' ? residentTemplate : nonResidentTemplate,
          prefill: {
            selectedCountryCode: country, // skips the country selection screen in Persona
          },
        });
      } else if (result) {
        // resume existing inquiry
        setPersonaPayload({
          personaAccountId: individual.persona_account_id,
          personaInquiryId: result.id,
          personaSessionToken: result.session_token,
        });
      }
    };

    if (
      individual.persona_inquiry_status === 'incomplete' &&
      location.pathname === pathnames.beneficial_owner_verification
    ) {
      getInquiryDetails();
    }
  }, [
    individual.persona_account_id,
    individual.persona_inquiry_status,
    country,
    location.pathname,
  ]);

  const submitInquiry = (persona_inquiry_id) => {
    setFieldValue('individual.persona_inquiry_id', persona_inquiry_id);
    handleSubmit();
  };

  return (
    <Switch>
      <Route path={pathnames.beneficial_owner} exact>
        <CountryForm />
      </Route>
      <Route path={pathnames.beneficial_owner_contact_info} exact>
        <NonResidentForm />
      </Route>
      <Route path={pathnames.beneficial_owner_verification} exact>
        {individual.persona_inquiry_status === 'incomplete' && (
          <PersonaVerification
            personaPayload={personaPayload}
            handleSubmit={submitInquiry}
          />
        )}
      </Route>
    </Switch>
  );
};

export default BeneficialOwner;
